import React, { useCallback, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import Skeleton from 'react-loading-skeleton';
import injectService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/injectService';
import { reportError } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';
import { IS_FRAME_SERVICE } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/frameService';
import {
    dispatchTrackingEvent,
    BREADCRUMBS_LINK_CLICK,
} from '@PROJECT_ROOT/assets/responsive-frontend/js/services/tracking';

// DESC: Vrijednost ovog ID-a treba biti usklađena sa "sharedData.breadcrumbsStructuredDataID" u "responsiveFrontendPagesConfiguration.json"
const ID_FOR_SCRIPT_STRUCTURED_DATA = 'breadcrumbs-structured-data';

export default function BreadCrumbs({
    breadcrumbs,
    isLoading,
    breadcrumbsStructuredData,
}) {
    const [portalRoot, setPortalRoot] = useState(null);
    const previousBreadcrumbsStructuredData = useRef(breadcrumbsStructuredData);

    useEffect(() => {
        const breadcrumbsPortalRoot = document.getElementById('breadcrumbsReact');
        setPortalRoot(breadcrumbsPortalRoot);
        if (breadcrumbsPortalRoot) {
            const skeletonSpan = document.getElementById('breadcrumbsStaticSkeleton');
            if (skeletonSpan && breadcrumbsPortalRoot.contains(skeletonSpan)) {
                try {
                    breadcrumbsPortalRoot.removeChild(skeletonSpan);
                } catch (error) {
                    reportError(new Error('Greška prilikom uklanjanja "breadcrumbsStaticSkeleton" : ', error));
                }
            }
        }
    }, []);

    useEffect(() => {
        if (previousBreadcrumbsStructuredData.current !== breadcrumbsStructuredData) {
            injectService.injectStructuredData(breadcrumbsStructuredData, ID_FOR_SCRIPT_STRUCTURED_DATA);
        }
        previousBreadcrumbsStructuredData.current = breadcrumbsStructuredData;
    }, [breadcrumbsStructuredData]);

    const handleTracking = useCallback(() => {
        if (!IS_FRAME_SERVICE) {
            dispatchTrackingEvent(BREADCRUMBS_LINK_CLICK);
        }
    }, []);

    const renderBreadcrumbsInnerContent = () => (
        <div className="breadcrumbsContentInner">
            {isLoading ? (
                // DESC: Height ovog elementa mora biti isti kao i kod gotovog elementa, na taj način nemamo CLS.
                <Skeleton className="breadcrumbsContent__staticSkeleton" />
            ) : (
                breadcrumbs && (
                    <ol className="breadcrumbs">
                        {breadcrumbs.map((breadcrumb, index) => (
                            <React.Fragment key={index}>
                                {breadcrumb.url ? (
                                    <li>
                                        <a
                                            href={breadcrumb.url}
                                            onClick={handleTracking}
                                            onAuxClick={(event) => {
                                                if (event.button === 1) {
                                                    handleTracking();
                                                }
                                            }}
                                        >
                                            <span>{breadcrumb.title}</span>
                                        </a>
                                    </li>
                                ) : (
                                    <li className="breadcrumbs__item--no-url">
                                        {breadcrumb.title}
                                    </li>
                                )}
                            </React.Fragment>
                        ))}
                    </ol>
                )
            )}
        </div>
    );

    return portalRoot ? createPortal(renderBreadcrumbsInnerContent(), portalRoot) : null;
}
